import { Controller } from 'stimulus'

export default class extends Controller {
  format() {
    const parsedAmount = Number(this.amount.replace(/\D/g, '')) / 100
    this.amount = parsedAmount.toLocaleString(undefined, {'minimumFractionDigits':2,'maximumFractionDigits':2})
    this.amount == '0' ? this.amount = '0.00' : this.amount
  }
  
  get amount() {
    return this.element.value
  }
  
  set amount(value) {
    return this.element.value = value
  }
}